module.exports = __webpack_public_path__ + "static/media/gl.59e18356.svg";